// VUE and dependancies
import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from './i18n/i18n.js'
import store from './store'

// Main Pages
import App from './App.vue'

import MainForm from '@/components/Page/MainForm.vue'
import Consult from '@/components/Page/Consult.vue'

// Sentry
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

// Others
import axios from 'axios'
import VueAxios from 'vue-axios'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'

import vSelect from 'vue-select'

import $ from 'jquery'

import moment from 'moment'
Vue.prototype.moment = moment

// Sentry
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});


// Cookie : Require dependencies & tell Vue to use the plugin
var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

function $_GET(param) {
	var vars = {};
	window.location.href.replace( location.hash, '' ).replace( 
		/[?&]+([^=&]+)=?([^&]*)?/gi,
		function( m, key, value ) { 
			vars[key] = value !== undefined ? value : '';
		}
	);

	if ( param ) {
		return vars[param] ? vars[param] : null;	
	}
	return vars;
}

//récupération des (éventuels) paramètres
var initLang = $('#app').attr("lang") || process.env.VUE_APP_I18N_LOCALE
var idForm = parseInt($('#app').attr("form") || process.env.VUE_APP_ID_FORM)

if ($_GET('id') != null) {
  idForm = parseInt($('#app').attr("form") || decodeURI($_GET('id')))
}
var urlMainForm = $('#app').attr("page") || process.env.VUE_APP_URL_SIGNALER
var stepmanager = $('#app').attr("stepmanager") || JSON.parse(process.env.VUE_APP_STEPMANAGER)
var anonymous = $('#app').attr("anonymous") || JSON.parse(process.env.VUE_APP_IS_ANONYMOUS)
var redirect = $('#app').attr("redirect") || process.env.VUE_APP_REDIRECT_AFTER_POST
var consultUrl = $('#app').attr("consult") || process.env.VUE_APP_CONSULT_URL
var vueAppBackendUrl = $('#app').attr("vueAppBackendUrl") || process.env.VUE_APP_BACKEND_URL
var vueAppModernApiUrl = $('#app').attr("vueAppModernApiUrl") || process.env.VUE_APP_MODERN_API_URL
var vueAppBaseUrl = $('#app').attr("vueAppBaseUrl") || process.env.VUE_APP_BASE_URL
var vueAppMapCountryRestrict = $('#app').attr("vueAppMapCountryRestrict") || process.env.VUE_APP_MAP_COUNTRY_RESTRICTION
var vueAppMapCityRestrict = $('#app').attr("vueAppMapCityRestrict") || process.env.VUE_APP_MAP_CITY_RESTRICTION

i18n.locale = initLang;
moment.locale(initLang);
Settings.defaultLocale = initLang

import
{
  MessagingService
}
  from './service/MessagingService.js'

// Vue.config.productionTip = true

import 'leaflet/dist/leaflet.css'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import '~theme/sass/sb-admin-2.scss'
import 'vue-datetime/dist/vue-datetime.css'
import 'vue-select/dist/vue-select.css';


Vue.filter('multitranslate', function multitranslate (str, separator) {
  separator = separator || ';'

  if (!str) {
    return ''
  }

  str = str.trim()

  var re = new RegExp('([a-z]{2})\:(.*?)(\\' + separator + '|$)', 'gi')

  if (!re.test(str)) {
    return str
  }

  re.lastIndex = 0

  var translations = {}
  var match
  while ((match = re.exec(str)) !== null) {
    if (match[1] && match[2]) {
      translations[match[1]] = match[2]
    }
  }

  return translations[i18n.locale]
})

if (/iPad|iPhone|iPod/i.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
  console.log('produit apple ; pas de messaging')
} else {
  //MessagingService.setEndpoints(vueAppBackendUrl, vueAppModernApiUrl);
  //MessagingService.init()
}

Vue.use(VueAxios, axios)
Vue.use(VueRouter)
Vue.component('v-select', vSelect)
Vue.component('datetime', Datetime);
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_GOOGLE_CAPTCHA_PUBLIC_KEY })

const routes = [
  { path: urlMainForm, component: MainForm },
  { path: consultUrl, component: Consult }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

new Vue({
    store,
    router,
    i18n,
    render: h => h(App, {
      props: { 
        lang:initLang, 
        form:idForm, 
        showStepmanager:stepmanager,
        isAnonymous:anonymous,
        redirect:redirect,
	      consultUrl:consultUrl,
        vueAppBackendUrl:vueAppBackendUrl,
        vueAppModernApiUrl:vueAppModernApiUrl,
        vueAppBaseUrl:vueAppBaseUrl,
        vueAppMapCountryRestrict:vueAppMapCountryRestrict,
        vueAppMapCityRestrict:vueAppMapCityRestrict,
      }
    })
  }).$mount('#app')
